import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';


class SeasonScheduledMatchModal extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			scheduledMatch: this.props.modalScheduledMatch,
			locations: [],
			teams: []
		};

		this.handleInputChg = this.handleInputChg.bind(this);
		this.handleSaveMatch = this.handleSaveMatch.bind(this);
	}

	componentDidMount() {
		// console.log('SeasonScheduledMatchModal: componentDidMount');
		this.initModalState(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		// console.log('SeasonScheduledMatchModal: UNSAFE_componentWillReceiveProps');
		this.initModalState(nextProps);
	}

	initModalState(props) {
		var _this = this;

		var seasonId = props.season._id;

		// Get Locations
		Axios.get('/api/locations/').then(function(responseLocations) {

		// Get Teams for this season
		Axios.get('/api/teams/season/' + seasonId).then(function(responseTeams) {

			var locations = responseLocations.data;
			var teams = responseTeams.data;

			_this.setState({
				scheduledMatch: props.modalScheduledMatch,
				locations: locations,
				teams: teams,
				disableSubmit: false
			});

		});
		});
	}

	render() {
		//console.log('SeasonScheduledMatchModal: render');
		//console.log(this.props.modalScheduledMatch);
		//console.log(this.props.season);
		//console.log(this.state);

		var scheduledMatch = this.state.scheduledMatch;
		var addEditText = "Ajout";
		if (scheduledMatch._id !== "0") {
			addEditText = "Modification";
		}

		return (
    	<Modal 
  			isOpen={this.props.showModal} 
    		//toggle={this.props.handleModalCancel}		// when clicking outside the modal
				size={"sm"}
    		className={this.props.className}>

        <form className="form-horizontal" onSubmit={this.handleSaveMatch}>
    		<ModalHeader>
    			{/* toggle={this.props.handleModalCancel}> displays a small X in header */}
    			Match<br/>{addEditText}
    		</ModalHeader>

    		<ModalBody>
					{this.dispForm()}
    		</ModalBody>

    		<ModalFooter>
      		<button type="button" className="btn btn-secondary btn-sm stdCommandButton2" 
      			onClick={this.props.handleModalCancel}> Annuler
      		</button>
      		<button type="submit" className="btn btn-primary btn-sm stdCommandButton2"> 
      			Enregistrer
      		</button>
    		</ModalFooter>
    		</form>
    	</Modal>
    )
	}

	dispForm() {
		var scheduledMatch = this.state.scheduledMatch;

		return (
			<div>
        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Date </span> <br/>
          <input className="form-control form-control-sm" type="date" id="date" 
          	value={scheduledMatch.date || ''}
            onChange={this.handleInputChg}></input>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span>Sous-saison</span>
		  		<select className="form-control form-control-sm input-sm" type="text" id="subSeasonId" 
		  			value={scheduledMatch.subSeasonId} onChange={this.handleInputChg}>
		  				{this.props.season.subSeasons.map(this.optSubSeasons)}
					</select>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Programme </span> <br/>
          <input className="form-control form-control-sm" type="text" id="week" 
          	value={scheduledMatch.week || ''}
            onChange={this.handleInputChg}></input>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Lieu </span> <br/>
		  		<select className="form-control form-control-sm input-sm" type="text" id="locationId" 
		  			value={scheduledMatch.locationId} onChange={this.handleInputChg}>
		  				<option value="0">Choisir un lieu</option>
		  				{this.state.locations.map(this.optLocations)}
					</select>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Équipe A </span> <br/>
 		  		<select className="form-control form-control-sm input-sm" type="text" id="team1Id" 
		  			value={scheduledMatch.team1Id} onChange={this.handleInputChg}>
		  				<option value="0">Choisir une équipe</option>
		  				{this.state.teams.map(this.optTeams)}
					</select>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Équipe B </span> <br/>
 		  		<select className="form-control form-control-sm input-sm" type="text" id="team2Id" 
		  			value={scheduledMatch.team2Id} onChange={this.handleInputChg}>
		  				<option value="0">Choisir une équipe</option>
		  				{this.state.teams.map(this.optTeams)}
					</select>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Statut </span> <br/>
 		  		<select className="form-control form-control-sm input-sm" type="text" id="status" 
		  			value={scheduledMatch.status} onChange={this.handleInputChg}>
		  				<option>Scheduled</option>
		  				<option>Pending approval</option>
		  				<option>Validated</option>
					</select>
				</div>
				</div>

			</div>
		)
	}

	optSubSeasons(ss, ssIdx, subSeasons) {
		return (
			<option value={ss.id} key={'ss.' + ssIdx}> {ss.name} </option>
		)
	}

	optLocations(loc, locIdx, locations) {
		return (
			<option value={loc._id} key={'loc.' + locIdx}> {loc.name} </option>
		)
	}

	optTeams(team, teamIdx, teams) {
		return (
			<option value={team._id} key={'team.' + teamIdx}> {team.name} </option>
		)
	}

	handleInputChg(e) {
		var scheduledMatch = this.state.scheduledMatch;
		scheduledMatch[e.target.id] = e.target.value;
		this.setState({	scheduledMatch: scheduledMatch });
	}

	handleSaveMatch(e) {
		// console.log('handleSaveMatch !');
		e.preventDefault();

		if (this.state.disableSubmit) {
			return;
		}

		var _this = this;
		var scheduledMatch = this.state.scheduledMatch;

		// Validation
		if ((scheduledMatch.date === '') || 
				(scheduledMatch.locationId === '0') || 
			  (scheduledMatch.team1Id === '0') || (scheduledMatch.team2Id === '0')) {
			alert('Vous devez spéficier tous les champs');
		
		}	else if (scheduledMatch.team1Id === scheduledMatch.team2Id) {
			alert('Les équipes doivent être différentes');

		} else {
			_this.setState({
				disableSubmit: true
			});

			// Post operation
			Axios.post('/api/scheduledMatchs/saveMatch', {
				matchObj: scheduledMatch,
			})
			.then(function(response) {
				_this.props.reloadData();
				
				_this.props.handleModalCancel();
			})
			.catch(function(error) {
				console.log('ERROR');
				console.log(error);
				_this.props.handleModalCancel();
			});

		}

	}

	isNumeric(n) {
		// not good for negative values
		return !isNaN(parseFloat(n)) && isFinite(n);
	}

}

export default SeasonScheduledMatchModal;